import { apiFetch } from '../App/api'

export function events(actionObj) {
    let loading = 'EVENTS_LOADING' 
    let success = 'EVENTS_SUCCESS' 
    let errorMessage = 'Unable to load events'

    var url = 'http://calvarychapelyelm.org/api/kiosk'

    let request = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    }
    
    return apiFetch(url, request, loading, success, errorMessage)
}